"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("title", null, "Trace Icons_1-3"), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M12.62,29.78v-12L5.08,5a1.78,1.78,0,0,1,0-1.65,1.56,1.56,0,0,1,1.36-.85H25.57a1.56,1.56,0,0,1,1.36.85,1.76,1.76,0,0,1,0,1.61l-7.56,12.8v9.28ZM6.43,3.83A.25.25,0,0,0,6.22,4a.48.48,0,0,0,0,.42l7.7,13V27.86l4.16-1.67V17.44L25.8,4.37a.46.46,0,0,0,0-.38.25.25,0,0,0-.21-.16Z"
})));
module.exports = exports.default;